module.exports = __webpack_public_path__ + "img/1505589450.96bb5c4d.jpg";